.app-accordion {
	background-color: #ffffff;
	// box-shadow: 0px 6px 17px rgba($primary, 0.1);
	margin: 16px 0;
	overflow: hidden;
	transition: all 300ms ease-out;
	border-radius: 10px;

	& > h3 {
		margin-bottom: 0;
	}

	&__trigger {
		color: $primary;
		background: #F6F4EF;
		padding: 18px 54px 18px 18px;
		position: relative;
		text-align: left;
		transition: background 300ms ease-out;
		width: 100%;
		display: flex;
		align-items: center;
		gap: 18px;
		flex-wrap: nowrap;
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
		border: 1px solid #EDE8DF;
		border-radius: 10px;
		text-transform: none !important;

		app-icon:not(.card-accordion__icon) {
			transition: inherit;
			width: 29px;
			height: 29px !important;
			display: flex;
			align-items: center;
			justify-content: center;
			background: transparent;
			vertical-align: middle;
			position: absolute;
			right: 18px;

			svg {
				@include svg-format(18px, 18px, currentColor);
			}
		}

		img {
			display: none;
		}

		&:hover {
			background: #EDE8DF;
			outline: none;

			app-icon {
				color: $secondary;
			}
		}

		&[aria-expanded="true"] {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
			background: #EDE8DF;
			border-color: #E2D9C9;
			border-bottom-color: #EDE8DF;
			transition: transform 300ms ease-out;

			app-icon:not(.card-accordion__icon) {
				transition: transform 300ms ease-out;
				transform: rotate(180deg);
				background: $primary;
				border-color: $primary;
				color: #ffffff;
			}
		}
	}

	&__content {
		visibility: visible;
		overflow: hidden;
		padding-inline: 18px;
		transition: max-height 300ms ease-out, visibility 300ms ease-out;
		background: #EDE8DF;
		border: 1px solid #E2D9C9;
		border-top: none;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;

		&[aria-hidden="true"] {
			max-height: 0;
			visibility: hidden;
			transition: max-height 300ms ease-out, visibility 300ms ease-out;
		}

		&-wrapper {
			padding-block: 18px;
			border-top: 1px solid #E2D9C9;
			font-size: 16px;

			p {
				width: 100%;
				max-inline-size: 100%;
			}

			& > :last-child {
				padding-bottom: 0;
				margin-bottom: 0;
			}
		}
	}
}
